// Уровни ухода (S2.7) — единые подписи для админки и витрины
export const CARE_LEVEL_LABELS = {
  light: 'Лёгкий',
  medium: 'Средний',
  demanding: 'Требовательный',
};

export const CARE_LEVEL_OPTIONS = [
  { value: 'light', label: CARE_LEVEL_LABELS.light },
  { value: 'medium', label: CARE_LEVEL_LABELS.medium },
  { value: 'demanding', label: CARE_LEVEL_LABELS.demanding },
];
